import { functions } from "./firebase";
import env from "@/env";

const getStripeSessionId = functions.httpsCallable("getStripeSessionId");

function urlForRoute(route) {
  return `${window.location.origin}${route}`;
}

export async function checkoutBooking({ bookingId, shopId, stripeCustomerId }) {
  const response = await getStripeSessionId({
    // eslint-disable-next-line @typescript-eslint/camelcase
    booking_id: bookingId,
    sessionOpts: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      success_url: urlForRoute(`/booking-confirmation/${bookingId}`),
      // eslint-disable-next-line @typescript-eslint/camelcase
      cancel_url: urlForRoute(
        `/shops/${shopId}?checkout_cancelled=true&bid=${bookingId}`
      )
    }
  });

  const sessionId = response.data;

  // eslint-disable-next-line no-undef
  const stripe = Stripe(env.stripe.key, {
    stripeAccount: stripeCustomerId
  });

  stripe.redirectToCheckout({ sessionId });
}
